export const CUSTOMERS_QUERY = 'customers';
